module.exports = __webpack_public_path__ + "static/media/signage-industrial-img1.6a3374be.jpg";